import { render, staticRenderFns } from "./TheLoading.vue?vue&type=template&id=2141d756&scoped=true"
import script from "./TheLoading.vue?vue&type=script&lang=js"
export * from "./TheLoading.vue?vue&type=script&lang=js"
import style0 from "./TheLoading.vue?vue&type=style&index=0&id=2141d756&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2141d756",
  null
  
)

export default component.exports